// extracted by mini-css-extract-plugin
export default {"root":"LinkDrawer_root__c0on0"};